module.exports = __webpack_public_path__ + "img/guide2.e67e2ab7.jpg";